import React, { useRef } from 'react';

export const BubbleArrow = ({
  position,
  backgroundColor,
  caretWidth,
}: {
  position: string;
  backgroundColor: string;
  caretWidth: number;
}) => {
  const ref = useRef<HTMLHeadingElement>(null);
  const border = `${caretWidth}px solid ${backgroundColor}`;
  const none = `${caretWidth}px solid transparent`;
  const margin = `calc(50% - ${caretWidth}px)`;
  const containerStyle: React.CSSProperties = {
    position: 'absolute',
    borderTop: position === 'above' ? border : none,
    borderBottom: position === 'below' ? border : none,
    borderLeft: position === 'left' ? border : none,
    borderRight: position === 'right' ? border : none,
    left: position === 'left' ? '98%' : position === 'above' || position === 'below' ? margin : 'auto',
    right: position === 'right' ? '98%' : 'auto',
    top: position === 'above' ? '98%' : position === 'left' || position === 'right' ? margin : 'auto',
    bottom: position === 'below' ? '98%' : 'auto',
  };
  return <div style={containerStyle} ref={ref}></div>;
};
